import * as React from 'react';
import { Grid, Box } from '@mui/material';
import ProductCard from './ProductCard';

const ProductGrid = ({
                         products,
                         onAddToCart,
                         buttonColor,
                         buttonTextColor,
                         priceColor,
                         showPrice,
                         // ⬇️ QO‘SHILDI
                         showCount,
                         quantityField,
                     }) => {
    const productMap = new Map();

    for (let product of products) {
        if (product.type === 'PRODUCT') {
            productMap.set(product.id, { ...product, types: [] });
        }
    }

    for (let product of products) {
        if (product.type === 'TYPE') {
            const match = product.name.match(/^(.+?)\(/);
            if (match) {
                const mainName = match[1].trim();
                for (let [, prod] of productMap.entries()) {
                    if (prod.name.startsWith(mainName)) {
                        prod.types.push(product);
                        break;
                    }
                }
            }
        }
    }

    return (
        <Box sx={{ width: '100%', margin: 0 }}>
            <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1.5, md: 2 }}
                sx={{ width: '100%', margin: 0 }}
            >
                {[...productMap.values()].map((product) => (
                    <Grid key={product.id} size={{ xs: 6, sm: 4, md: 2.4 }}>
                        <ProductCard
                            product={product}
                            onAddToCart={onAddToCart}
                            buttonColor={buttonColor}
                            buttonTextColor={buttonTextColor}
                            priceColor={priceColor}
                            showPrice={showPrice}
                            // ⬇️ QO‘SHILDI
                            showCount={showCount}
                            quantityField={quantityField}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default ProductGrid;
